import { Component, Injector, OnInit, Input } from '@angular/core';
import { ThemesLayoutBaseComponent } from '../themes/themes-layout-base.component';
import { ChangeUserLanguageDto, ProfileServiceProxy } from '@shared/service-proxies/service-proxies';
import { filter as _filter } from 'lodash-es';
import { DateTimeService } from '@app/shared/common/timing/date-time.service';
import { locale, loadMessages, formatMessage } from "devextreme/localization";
import * as deMessages from "devextreme/localization/messages/de.json";
import * as nlMessages from "devextreme/localization/messages/de.json";
import * as enMessages from "devextreme/localization/messages/de.json";
import * as esMessages from "devextreme/localization/messages/de.json";
import * as frMessages from "devextreme/localization/messages/de.json";
import * as itMessages from "devextreme/localization/messages/de.json";
import * as ptMessages from "devextreme/localization/messages/de.json";
import * as ruMessages from "devextreme/localization/messages/de.json";
import * as viMessages from "devextreme/localization/messages/de.json";
import * as trMessages from "devextreme/localization/messages/de.json";
import * as arMessages from "devextreme/localization/messages/de.json";
import * as thMessages from "devextreme/localization/messages/de.json";
import * as zhMessages from "devextreme/localization/messages/de.json";




@Component({
    selector: 'language-switch-dropdown',
    templateUrl: './language-switch-dropdown.component.html'
})
export class LanguageSwitchDropdownComponent extends ThemesLayoutBaseComponent implements OnInit {

    languages: abp.localization.ILanguageInfo[];
    currentLanguage: abp.localization.ILanguageInfo;

    @Input() isDropup = false;
    @Input() customStyle = 'btn btn-icon btn-dropdown btn-clean btn-md mr-1';

    public constructor(
        injector: Injector,
        private _profileServiceProxy: ProfileServiceProxy,
        _dateTimeService: DateTimeService,
   
    ) {
        super(injector, _dateTimeService);
        this.initMessages();
    }
    initMessages() {
        loadMessages(deMessages);
        loadMessages(nlMessages);
        loadMessages(enMessages);
        loadMessages(esMessages);
        loadMessages(frMessages);
        loadMessages(itMessages);
        loadMessages(ptMessages);
        loadMessages(viMessages);
        loadMessages(trMessages);
        loadMessages(arMessages);
        loadMessages(ruMessages);
        loadMessages(thMessages);
        loadMessages(zhMessages);
    }
    ngOnInit(): void {
        this.languages = _filter(this.localization.languages, l => (l).isDisabled === false);
        this.currentLanguage = this.localization.currentLanguage;

        locale(this.currentLanguage.name);
      //console.log(this.currentLanguage.name);
    }

    changeLanguage(languageName: string): void {
        const input = new ChangeUserLanguageDto();
        input.languageName = languageName;

        this._profileServiceProxy.changeLanguage(input).subscribe(() => {
            abp.utils.setCookieValue(
                'Abp.Localization.CultureName',
                languageName,
                new Date(new Date().getTime() + 5 * 365 * 86400000), //5 year
                abp.appPath
            );
            window.location.reload();
        });
    }
   
}
